import { useState, useEffect } from "react";

const FormInput = (props) => {
    const [focused, setFocused] = useState(false);
    const { label, errorMessage, onChange, id, count, submitted, ...inputProps } = props;

    // Effect to reset the focus state when the form is submitted
    useEffect(() => {
        if (submitted) {
            setFocused(false); // Reset focus when form is submitted
        }
    }, [submitted]);

    const handleFocus = (e) => {
        setFocused(true)
    };

    if (props.inputtype !== "textarea") {
        return (
            <div className="formInput">
                <label>{label}</label>
                <input {...inputProps} onChange={onChange} onBlur={handleFocus} focused={focused.toString()} title="" />
                <span className="error-message">{errorMessage}</span>
            </div>
        )
    }
    else {
        return (
            <div className="formInput">
                <label>{label}</label>
                <textarea {...inputProps} onChange={onChange} onBlur={handleFocus} focused={focused.toString()} title="" />
                <p>{count}/{inputProps.maxLength}</p>
                <span className="error-message">{errorMessage}</span>
            </div>
        )
    }
}
export default FormInput